import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "doctor_cards" } },
    _vm._l(_vm.doctors, function (doctor) {
      return _c(
        "div",
        {
          key: doctor.translit,
          staticClass:
            "d-flex flex-column align-center gr-4 py-4 elevation-1 rounded",
          attrs: {
            "data-qa": "doctor_cards_item",
            "data-qa-translit": doctor.translit,
          },
        },
        [
          _c(
            "div",
            { staticClass: "border-b-sm w-100 px-4" },
            [
              _c(VImg, {
                staticClass: "mx-auto",
                attrs: {
                  "data-qa": "doctor_cards_item_avatar",
                  src: doctor.avatar,
                  "lazy-src": "/static/_v1/pd/icons/ui-kit/photo/no-avatar.svg",
                  alt: "/",
                  width: "150",
                  height: "150",
                  contain: "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column text-center gr-1 px-4" },
            [
              _c(
                "a",
                {
                  staticClass:
                    "text-center text-subtitle-1 primary--text text-decoration-none d-block",
                  attrs: {
                    "data-qa": "doctor_cards_item_url",
                    href: doctor.url,
                  },
                },
                [_vm._v("\n        " + _vm._s(doctor.fio) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-body-2 text-secondary--text",
                  attrs: { "data-qa": "doctor_cards_item_town_name" },
                },
                [_vm._v("\n        " + _vm._s(doctor.townName) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-body-2 text-secondary--text",
                  attrs: { "data-qa": "doctor_cards_item_specialities" },
                },
                [
                  _vm._l(doctor.specialities, function (spec, index) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            index === 0 ? spec : ` • ${spec.toLowerCase()}`
                          ) +
                          "\n        "
                      ),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center text-body-2 text-secondary--text" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.t("Заблокирован до", _setup.options)) +
                      "\n        "
                  ),
                  _c(
                    "span",
                    {
                      attrs: {
                        "data-qa": "doctor_cards_item_fraud_mark_expire_date",
                      },
                    },
                    [_vm._v(_vm._s(doctor.fraudMarkExpireDate))]
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }